import { Controller } from "@hotwired/stimulus"

// Simple controller for toggling all date checkboxes
export default class extends Controller {
  static targets = ["allCheckbox", "dateCheckbox"]
  static values = { type: String }

  toggleAll(event) {
    const checked = event.target.checked
    this.dateCheckboxTargets.forEach(cb => cb.checked = checked)
  }

  updateAll() {
    const allChecked = this.dateCheckboxTargets.every(cb => cb.checked)
    this.allCheckboxTarget.checked = allChecked
  }
}
